import { useMutation } from '@tanstack/react-query'
import { subAdminEnabled } from '../index'

const useSubAdminEnabled = () =>
  useMutation({
    mutationFn: subAdminEnabled,
  })

export default useSubAdminEnabled
